export const DpCMSPages = {

    CsvUpload: {
        path: 'my-account/csvUpload'
    },

    ShopClosed: {
        path: 'shop-closed',
        route: '/shop-closed'
    }
};